module.exports = __webpack_public_path__ + "prod/20261104151832/img/smallProgram.e5352668.jpg";